
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-apps/sales-effectiveness",
      function () {
        return require("private-next-pages/data-apps/sales-effectiveness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-apps/sales-effectiveness"])
      });
    }
  